import { toast } from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const useMedicalHistoryDelete = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (medicalHistoryId) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.delete(
        `${tenantVal}/patientmedicalhistory/delete`,
        {
          data: {
            id: Number(medicalHistoryId),
          },
        }
      );
      return response;
    },
    onSuccess: () => {
      toast.success("Medical history record has been deleted");
      queryClient.invalidateQueries({ queryKey: ["medicalHistory"] });
    },
  });
};

export { useMedicalHistoryDelete };
